/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SearchRequest
 */
export interface SearchRequest {
  /**
   * Искомые слова
   * @type {Array<string>}
   * @memberof SearchRequest
   */
  words: Array<string>
}

/**
 * Check if a given object implements the SearchRequest interface.
 */
export function instanceOfSearchRequest(value: object): value is SearchRequest {
  if (!('words' in value) || value['words'] === undefined) return false
  return true
}

export function SearchRequestFromJSON(json: any): SearchRequest {
  return SearchRequestFromJSONTyped(json, false)
}

export function SearchRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SearchRequest {
  if (json == null) {
    return json
  }
  return {
    words: json['words'],
  }
}

export function SearchRequestToJSON(value?: SearchRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    words: value['words'],
  }
}
